export default "__VITE_ASSET__382e655d__"